(function () {
  if (window.__angBuy) return;
  window.__angBuy = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var toast;

  function show(html) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ang-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = html;
    requestAnimationFrame(function () { toast.classList.add('is-on'); });
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 3500);
  }

  function cartIcon() {
    var icons = document.querySelectorAll('cart-icon');
    for (var i = 0; i < icons.length; i++) { if (icons[i].getClientRects().length) return icons[i]; }
    return icons[0] || null;
  }

  // Le visuel du produit s'envole en arc jusqu'à l'icône panier
  function flyToCart(card) {
    var icon = cartIcon();
    var img = card && card.querySelector('img');
    if (reduce || !icon || !img || !img.animate) return Promise.resolve();
    var from = img.getBoundingClientRect();
    var to = icon.getBoundingClientRect();
    if (!from.width || !to.width) return Promise.resolve();
    var size = Math.min(from.width, from.height, 160);
    var clone = document.createElement('img');
    clone.src = img.currentSrc || img.src;
    clone.alt = '';
    clone.className = 'ang-fly';
    clone.style.width = size + 'px';
    clone.style.height = size + 'px';
    var sx = from.left + from.width / 2 - size / 2;
    var sy = from.top + from.height / 2 - size / 2;
    clone.style.left = sx + 'px';
    clone.style.top = sy + 'px';
    document.body.appendChild(clone);
    var dx = to.left + to.width / 2 - (sx + size / 2);
    var dy = to.top + to.height / 2 - (sy + size / 2);
    var anim = clone.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, borderRadius: '12px' },
      { transform: 'translate(' + dx * 0.45 + 'px,' + (dy * 0.45 - 120) + 'px) scale(.6) rotate(-10deg)', opacity: 1, borderRadius: '40%', offset: 0.5 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12) rotate(-20deg)', opacity: 0.2, borderRadius: '50%' }
    ], { duration: 800, easing: 'cubic-bezier(.55,0,.35,1)', fill: 'forwards' });
    return anim.finished.then(function () { clone.remove(); }, function () { clone.remove(); });
  }

  function refreshBubble(count) {
    var icon = cartIcon();
    if (!icon) return;
    if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(count);
    icon.classList.remove('ang-cart-pop');
    void icon.offsetWidth;
    icon.classList.add('ang-cart-pop');
    setTimeout(function () { icon.classList.remove('ang-cart-pop'); }, 700);
  }

  function addToCart(form) {
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Erreur'); return d; }); });
  }

  // Cartes produit : « Ajouter au panier » avec animation vers le panier
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ang-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var card = form.closest('product-card');
    btn.setAttribute('aria-busy', 'true');
    var flight = flyToCart(card);
    addToCart(form)
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) { return flight.then(function () { return cart; }); })
      .then(function (cart) {
        refreshBubble(cart.item_count);
        show('Ajouté au panier ✓ <a href="' + root + 'cart">Voir le panier</a>');
      })
      .catch(function (err) { show(err.message || 'Impossible d’ajouter ce produit.'); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  }, true);

  // Page produit : « Acheter maintenant » = paiement direct de ce produit (variante + quantité choisies)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ang-buy-now]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var form = btn.closest('form');
    var idInput = form && form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    var qtyInput = document.querySelector('.product-information input[name="quantity"]') || (form && form.querySelector('[name="quantity"]'));
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    btn.setAttribute('aria-busy', 'true');
    window.location.href = root + 'cart/' + idInput.value + ':' + qty;
  }, true);
})();
